
import { getDetergents } from "controllers/Washwith";
import { withMultiButtonSelectHOC } from "shared/HOC";
import { sortArrayPipe } from "shared/pipes";



async function dataStream(callback) {
  const detergent = await getDetergents();
  callback(sortArrayPipe.transform(detergent, 'value'));
}


const WashingDetergentButton = withMultiButtonSelectHOC([],dataStream);
export default WashingDetergentButton;
